
export { default as getTrailLocationName } from "./utils/getTrailLocationName"
export { default as useTrailPhotos } from "./hooks/useTrailPhotos"